var _circle, _path, _ellipse, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 20,
    cy: 10.6667,
    r: 4,
    fill: "#9FA6AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4866 25.2644C22.2383 24.4957 22.6667 23.6098 22.6667 22.6666C22.6667 20.3982 20.1884 18.4606 16.6946 17.6896C17.7021 17.4608 18.8213 17.3333 20 17.3333C24.4183 17.3333 28 19.1242 28 21.3333C28 23.2885 25.1946 24.916 21.4866 25.2644Z",
    fill: "#9FA6AB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 13.3333,
    cy: 22.6666,
    rx: 9.33333,
    ry: 5.33333,
    fill: "#9FA6AB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3333,
    cy: 9.33333,
    r: 5.33333,
    fill: "#9FA6AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.dfe896c8d2d2c108ce52ac7618e9f873.svg";
export { ForwardRef as ReactComponent };